import { BaseResponseInterface } from '@interface/public';
import { AxiosAPI } from '@server/_axios';

const apiPath = { // API地址
  news: 'website/article/' // 新闻
};

//----- 获取置顶新闻 Start -----//
export interface NewsInterface { // 新闻
  article_id: string; // 标识
  article_title: string; // 标题
  article_introduction: string; // 介绍
  article_cover_address: string; // 封面
  article_nick_name: string; // 发布人
  biz_updateded_at: number; // 更新时间
  published_at: number; // 发布时间
}

export interface RequestGetNewsTop {
}

export interface ResponseGetNewsTop extends BaseResponseInterface {
  data: {
    article_data: NewsInterface[];
    total: number; // 数量
  };
}

export async function AxiosGetNewsTop(params: RequestGetNewsTop): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.news }topthree`,
    params
  });
}

//----- 获取置顶新闻 End -----//

//----- 获取新闻列表 Start -----//
export interface RequestGetNewsList {
  page_number: number;
  page_size: number;
}

export interface ResponseGetNewsList extends BaseResponseInterface {
  data: {
    article_data: NewsInterface[];
    page_number: number;
    page_size: number;
    total: number;
  };
}

export async function AxiosGetNewsList(params: RequestGetNewsList): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.news }list`,
    params
  });
}

//----- 获取新闻列表 End -----//

//----- 获取新闻详情 Start -----//
export interface RequestGetNewsDetail {
  article_id: string;
}

export interface ResponseGetNewsDetail extends BaseResponseInterface {
  data: {
    article_id: string; // 标识
    article_title: string; // 标题
    article_introduction: string; // 介绍
    article_text: string; // 内容
    article_cover_address: string; // 封面
    article_nick_name: string; // 作者
    biz_updated_at: number; // 更新时间
    published_at: number; // 上线时间
    is_top: string; // 置顶
  };
}

export async function AxiosGetNewsDetail(params: RequestGetNewsDetail): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.news }query`,
    params
  });
}

//----- 获取新闻详情 End -----//